module.exports = __webpack_public_path__ + "5035b32ec9c8a60597a3e9e7da670d11.png";